import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { programs } from '../../../../../redux/programs/action';
import MyProgramComponent from '../components/programs.component';
import { selectProgramsQueryItems } from '../../../../../redux/programs/selector';


const Myprogram = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const queryItems = useSelector(selectProgramsQueryItems)

    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [
        selectedProgram,
        setSelectedProgram
    ] = useState<any>([])

    const fetchQueryById = () => {
        dispatch(programs.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-program-subscriptions/query-by-current-user`, entity: 'programs', jsonData: {

                Records: [
                    {
                        "Id": parmas?.id

                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })

    }


    useEffect(
        () => {

            if (parmas?.id > 0) {
                fetchQueryById()

            } else {
                setIsLoading(false)
            }

        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                const querydata: any = queryItems?.result?.items
                setSelectedProgram(querydata)

                const forumGroupsItemsData: any = queryItems?.result?.items?.ForumGroups?.map((item: any) => {
                    const itemData = {
                        Id: item?.Id,
                        Name: item?.Name,
                        Description: item?.Description,
                        DisplayOrder: item?.DisplayOrder,



                    }
                    return itemData
                })
            

            }
        },
        [isQuery]
    )



    const back = () => {
        navigate('/oneuser/programs/myprograms')
    }


    return (
        <>


            {isLoading ? <PageLoader /> :


                <MyProgramComponent
                    selectedProgram={selectedProgram}
                    back={back}
                />
            }

        </>
    )

}

export default Myprogram;